module.exports = __webpack_public_path__ + "/img/SON-mvqMQb.svg";